"use client";

import { withFallback } from "../with-fallback";

export const GenerateWithdrawalReceiptElement = withFallback<
	"generate-withdrawal-receipt-element",
	true
>({
	displayName: "GenerateWithdrawalReceiptElement",
	type: "generate-withdrawal-receipt-element",
});
